import { find, forEach, get, isArray, isEqual } from 'lodash';

export const getChangedPaths = (
  applicationStepData: Array<Record<string, any>>,
  draftData: Array<Record<string, any>>,
  uiKey: string | undefined,
): string[] => {
  if (!draftData) return [];

  const getValuesFromObjects = (paths: Array<string>) => {
    return paths.filter((path) => {
      const applicationFieldValue = get(applicationStepData, path);
      const draftFieldValue = get(draftData, path);
      return !isEqual(applicationFieldValue, draftFieldValue);
    });
  };

  const getValuesFromAuthorizedRepresentative = (paths: Array<string>) => {
    const changedPaths: string[] = [];

    forEach(applicationStepData, (appObj, index) => {
      const draftObj = draftData[index];

      forEach(paths, (path) => {
        const appValue = get(appObj, path);
        const draftValue = get(draftObj, path);

        if (!isEqual(appValue, draftValue)) {
          changedPaths.push(`${index}.${path}`);
        }
      });
    });

    return changedPaths;
  };

  const getValuesFromShareholders = () => {
    const changedPaths: string[] = [];

    const categories = [
      {
        name: 'businesses',
        fields: [
          'data.companyLicense.legalName',
          'data.companyLicense.legalType',
          'data.companyLicense.licenseNumber',
          'data.companyLicense.dateOfEstablishment',
          'data.city',
          'data.poBox',
          'data.addressLine',
          'data.phoneNo',
          'data.country',
          'shares',
        ],
      },
      {
        name: 'individuals',
        fields: [
          'data.firstName',
          'data.lastName',
          'data.dateOfBirth',
          'data.nationality',
          'data.isPep',
          'data.mobileNo',
          'shares',
        ],
      },
      {
        name: 'beneficialOwners',
        fields: [
          'data.firstName',
          'data.lastName',
          'data.dateOfBirth',
          'data.nationality',
          'data.isPep',
          'data.mobileNo',
          'shares',
        ],
      },
    ];

    forEach(categories, ({ name, fields }) => {
      const appArray = get(applicationStepData, name, []);
      const draftArray = get(draftData, name, []);

      forEach(appArray, (appObj, index) => {
        const appUid = get(appObj, 'data.uid');
        const draftObj = find(draftArray, (obj) => get(obj, 'data.uid') === appUid);

        forEach(fields, (field) => {
          const appValue = get(appObj, field);
          const draftValue = get(draftObj, field);

          if (!isEqual(appValue, draftValue)) {
            changedPaths.push(`${name}.${index}.${field}`);
          }
        });
      });
    });

    return changedPaths;
  };

  if (uiKey === 'companyInformation') {
    return getValuesFromObjects([
      'companyLicense.legalName',
      'companyLicense.legalType',
      'companyLicense.city',
      'companyLicense.licenseNumber',
      'companyLicense.licenseExpiryDate',
      'taxRegistrationCertificate.number',
    ]);
  }

  if (uiKey === 'addresses') {
    return getValuesFromObjects([
      'headOffice.emirate',
      'headOffice.phoneNumber'
    ]);
  }

  if (uiKey === 'authorizedRepresentative') {
    return getValuesFromAuthorizedRepresentative([
      'firstName',
      'lastName',
      'dateOfBirth',
      'nationality',
      'isPep',
      'isAuthorizedSignatory',
      'mobileNo',
      'email',
    ]);
  }

  if (uiKey === 'shareholders') {
    return getValuesFromShareholders();
  }

  return [];
};
